/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-02 9:08:27
 *
 *******************************************************/
// @flow
import type { Action } from './store.type';

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
type GET_PRODUCTS_REQUEST_TYPE = 'GET_PRODUCTS_REQUEST';

export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
type GET_PRODUCTS_SUCCESS_TYPE = 'GET_PRODUCTS_SUCCESS';

export const GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE';
type GET_PRODUCTS_FAILURE_TYPE = 'GET_PRODUCTS_FAILURE';

// Search product
export const SEARCH_PRODUCTS_REQUEST = 'SEARCH_PRODUCTS_REQUEST';
type SEARCH_PRODUCTS_REQUEST_TYPE = 'SEARCH_PRODUCTS_REQUEST';

export const SEARCH_PRODUCTS_SUCCESS = 'SEARCH_PRODUCTS_SUCCESS';
type SEARCH_PRODUCTS_SUCCESS_TYPE = 'SEARCH_PRODUCTS_SUCCESS';

export const SEARCH_PRODUCTS_FAILURE = 'SEARCH_PRODUCTS_FAILURE';
type SEARCH_PRODUCTS_FAILURE_TYPE = 'SEARCH_PRODUCTS_FAILURE';

// -----------
export const GET_PREVIEW_PRODUCTS_REQUEST = 'GET_PREVIEW_PRODUCTS_REQUEST';
type GET_BEST_SELLING_PRODUCTS_REQUEST_TYPE = 'GET_PREVIEW_PRODUCTS_REQUEST';

export const GET_PREVIEW_PRODUCTS_SUCCESS = 'GET_PREVIEW_PRODUCTS_SUCCESS';
type GET_BEST_SELLING_PRODUCTS_SUCCESS_TYPE = 'GET_PREVIEW_PRODUCTS_SUCCESS';

export const GET_PREVIEW_PRODUCTS_FAILURE = 'GET_PREVIEW_PRODUCTS_FAILURE';
type GET_BEST_SELLING_PRODUCTS_FAILURE_TYPE = 'GET_PREVIEW_PRODUCTS_FAILURE';

export const RESET_PRODUCT_LIST = 'RESET_PRODUCT_LIST';
type RESET_PRODUCT_LIST_TYPE = 'RESET_PRODUCT_LIST';

type ProductType = {
  name: string,
  status: string,
  type: string
};

type ProductSuccess = {
  data: Array<ProductType>,
  total: number
};

type Product = {
  id: String,
  title?: string,
  original_tags?: Array,
  available?: boolean,
  collections?: Array,
  compare_at_price_max?: number,
  compare_at_price_min?: number,
  price_max?: Number,
  price_min?: Number,
  review_ratings?: Number,
  product_type?: string,
  product_category?: string,
  published_at?: string,
  vendor?: string,
  tags?: Array<string>,
  images?: Array<string>,
  body_html?: string,
  handle?: string
};
type SearchProducts = {
  products: Array<Product>,
  affected_by_performance_ranking: boolean,
  affected_by_merchandising: boolean,
  total_collection: number,
  total_page: number,
  total_product: number,
  from_cache?: Boolean
};

type ProductFailure = {
  error: any
};

type GetBestSellingProductsRequestAction = Action<GET_BEST_SELLING_PRODUCTS_REQUEST_TYPE, null>;

type BestSellingProductSuccess = {
  data: Array<Record<string, any>>,
  total: number
};

type GetBestSellingProductsSuccessAction = Action<
  GET_BEST_SELLING_PRODUCTS_SUCCESS_TYPE,
  BestSellingProductSuccess
>;

type GetBestSellingProductsFailureAction = Action<
  GET_BEST_SELLING_PRODUCTS_FAILURE_TYPE,
  ProductFailure
>;

type GetProductsRequestAction = Action<GET_PRODUCTS_REQUEST_TYPE, null>;

type GetProductsSuccessAction = Action<GET_PRODUCTS_SUCCESS_TYPE, ProductSuccess>;

type GetProductsFailureAction = Action<GET_PRODUCTS_FAILURE_TYPE, ProductFailure>;

// Search product
type SearchProductsRequestAction = Action<SEARCH_PRODUCTS_REQUEST_TYPE, null>;

type SearchProductsSuccessAction = Action<SEARCH_PRODUCTS_SUCCESS_TYPE, SearchProducts>;

type SearchProductsFailureAction = Action<SEARCH_PRODUCTS_FAILURE_TYPE, ProductFailure>;

type ResetProductListAction = Action<RESET_PRODUCT_LIST_TYPE, {}>;
// Update recommend products
export const UPDATE_RECOMMEND_PRODUCTS = 'UPDATE_RECOMMEND_PRODUCTS';
type UPDATE_RECOMMEND_PRODUCTS_TYPE = 'UPDATE_RECOMMEND_PRODUCTS';
type UpdateRecommendProductsRequestAction = Action<UPDATE_RECOMMEND_PRODUCTS_TYPE, any>;

export type ProductAction =
  | GetProductsRequestAction
  | GetProductsSuccessAction
  | GetProductsFailureAction
  | SearchProductsRequestAction
  | SearchProductsSuccessAction
  | SearchProductsFailureAction
  | GetBestSellingProductsRequestAction
  | GetBestSellingProductsSuccessAction
  | GetBestSellingProductsFailureAction
  | ResetProductListAction
  | UpdateRecommendProductsRequestAction;

export type ProductState = {
  loading: boolean,
  success: boolean,
  error: any,
  products: Array<ProductType>
};
